<style scoped>
    @import url("../../../styles/smartControl/dialogMsg.scss");
</style>

<template>
    <div class="box_dialogMsg" @click="callFather()">

        <span v-if="msgFromFather == 'Atualizado.'" class="cardMsg">
            <v-icon size="72" class="mb-2">mdi-check-decagram</v-icon>
            {{ msgFromFather }}
        </span>

        <span v-if="msgFromFather == 'Não foi possível atualizar. Tente novamente mais tarde.'" class="cardMsg">
            <v-icon size="72" class="mb-2">mdi-message-alert</v-icon>
            {{ msgFromFather }}
        </span>

    </div>
</template>

<script>
//import axios from 'axios'

export default {

    props:['msgFromFather'],

    data() {
        return {

            // -- ?
        }
    },

    methods: {
        callFather() { this.$emit('fromDialogMsg') }, // chamada que torna flag dialog false no pai.
    },

    created() {
        //
    }
}
</script>